import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Executive Search', href: 'https://mainframesolutions.net/mainrecruit-workforce-strategy/', external: true },
  { label: 'BuildFit AI', href: '/buildfit-ai', external: false },
  { label: 'AI Governance', href: 'https://mainframesolutions.net/maingov-ai-operational-governance/', external: true },
  { label: 'Software Development', href: 'https://mainframesolutions.net/mainsoft-custom-software/', external: true },
  { label: 'Operational Systems', href: 'https://mainframesolutions.net/mainweb-website-design/', external: true },
];

const siteLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Jeff Dumè', href: '/about' },
  { label: 'Speaking', href: '/speaking' },
  { label: 'Board & Advisory', href: '/board-advisory' },
  { label: 'Press & Media', href: '/press-media' },
];

export default function Footer() {
  return (
    <footer className="bg-near-black py-12 md:py-16 lg:py-18" aria-label="Site footer">
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-8 mb-10 md:mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 rounded-lg shrink-0 flex items-center justify-center bg-gold">
                <span className="text-charcoal font-extrabold tracking-tight select-none" style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '16px', letterSpacing: '-0.02em' }}>JD</span>
              </div>
              <span className="text-white font-semibold">Jeff Dumè</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              Founder of BuildFit AI and Mainframe Solutions. Helping organizations reduce mis-hires, improve retention, and create more consistent hiring decisions through human-led AI.
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href="https://www.linkedin.com/in/jdume/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Jeff Dumè on LinkedIn"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/50 hover:border-gold hover:text-gold transition-colors"
              >
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Site Navigation */}
          <nav aria-label="Footer site navigation" className="md:col-span-1">
            <p className="text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-5">Navigation</p>
            <ul className="space-y-3">
              {siteLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/50 text-sm hover:text-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Footer services navigation" className="md:col-span-1">
            <p className="text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-5">Services</p>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/50 text-sm hover:text-gold transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-white/50 text-sm hover:text-gold transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          {/* Connect */}
          <div className="md:col-span-1">
            <p className="text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-5">Connect</p>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-white/70 text-sm hover:text-gold transition-colors">
                  Contact Jeff
                </Link>
              </li>
              <li>
                <Link to="/speaking" className="text-white/50 text-sm hover:text-gold transition-colors">
                  Speaking Inquiries
                </Link>
              </li>
              <li>
                <a
                  href="https://meetings-na2.hubspot.com/mainframesolutions/buildfitaistrategy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/50 text-sm hover:text-gold transition-colors"
                >
                  Book a Strategy Call
                </a>
              </li>
              <li>
                <a
                  href="https://buildfitai.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/50 text-sm hover:text-gold transition-colors"
                >
                  Visit BuildFit AI
                </a>
              </li>
              <li>
                <a
                  href="https://mainframesolutions.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/50 text-sm hover:text-gold transition-colors"
                >
                  Visit Mainframe Solutions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">
            &copy; {new Date().getFullYear()} Jeff Dumè. All rights reserved.
          </p>
          <div className="flex gap-5">
            <Link
              to="/privacy-policy"
              className="text-white/25 text-xs hover:text-white/50 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-use"
              className="text-white/25 text-xs hover:text-white/50 transition-colors"
            >
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}